import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import "./assets/styles/base.scss";
import "./assets/styles/common.scss";
import VConsole from 'vconsole';
import { rem2px } from "@/utils/remAdapter";

if (process.env.NODE_ENV === 'development') {
  new VConsole();
}

createApp(App)
.use(store)
.use(router)
.use(Vant)
.mixin({
    methods: {
        rem2px,
    }
})
.mount('#app')
